import React from 'react'
import { withIcon } from '../../withIcon'

function SlideNextIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.5 18.5793L9.5 5.42024C9.5 5.25505 9.58423 5.10438 9.71441 5.03629C9.84362 4.96933 9.99581 4.99611 10.1021 5.10772L16.3859 11.6872C16.538 11.8457 16.538 12.1538 16.3859 12.3134L10.1021 18.8918C9.99581 19.0034 9.84362 19.0313 9.7144 18.9632C9.58423 18.8962 9.5 18.7456 9.5 18.5793Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SlideNextIcon)
